import * as XLSX from "xlsx";

const padDatePart = (value) => String(value).padStart(2, "0");

const formatDateParts = (year, month, day) => {
  const date = new Date(Date.UTC(year, month - 1, day));

  if (
    date.getUTCFullYear() !== year ||
    date.getUTCMonth() + 1 !== month ||
    date.getUTCDate() !== day
  ) {
    return null;
  }

  return `${year}-${padDatePart(month)}-${padDatePart(day)}`;
};

const expandShortYear = (year) => {
  if (year >= 100) {
    return year;
  }

  return year >= 70 ? 1900 + year : 2000 + year;
};

export const normalizeUploadDate = (value) => {
  if (value === null || value === undefined || value === "") {
    return value;
  }

  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) {
      return null;
    }

    return formatDateParts(
      value.getFullYear(),
      value.getMonth() + 1,
      value.getDate(),
    );
  }

  if (typeof value === "number") {
    if (!Number.isFinite(value) || value <= 0) {
      return null;
    }

    const excelDate = XLSX.SSF.parse_date_code(value);

    return excelDate
      ? formatDateParts(excelDate.y, excelDate.m, excelDate.d)
      : null;
  }

  if (typeof value !== "string") {
    return null;
  }

  const dateString = value.trim();
  if (!dateString) {
    return "";
  }

  if (/^\d+(\.\d+)?$/.test(dateString)) {
    return normalizeUploadDate(Number(dateString));
  }

  const isoDate = dateString.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
  if (isoDate) {
    return formatDateParts(
      Number(isoDate[1]),
      Number(isoDate[2]),
      Number(isoDate[3]),
    );
  }

  const shortDate = dateString.match(
    /^(\d{1,2})[./-](\d{1,2})[./-](\d{2}|\d{4})$/,
  );
  if (shortDate) {
    const firstPart = Number(shortDate[1]);
    const secondPart = Number(shortDate[2]);
    const year = expandShortYear(Number(shortDate[3]));

    // Uploaded templates use UK-style dates. If only the second part can be
    // the day, also accept an unambiguous US-style date.
    const [day, month] =
      firstPart <= 12 && secondPart > 12
        ? [secondPart, firstPart]
        : [firstPart, secondPart];

    return formatDateParts(year, month, day);
  }

  return null;
};

export const isValidUploadDate = (value) =>
  value === null ||
  value === undefined ||
  value === "" ||
  (typeof value === "string" &&
    /^\d{4}-\d{2}-\d{2}$/.test(value) &&
    normalizeUploadDate(value) === value);
